import 'whatwg-fetch';
import 'promise-polyfill/lib/polyfill';

export default class Videos {
	constructor() {
		this.gfycatInit();
		const mediaQueryBasedSourcesHandler = () => {
			const videoElementList = document.querySelectorAll('video[data-media-query-based]') as NodeListOf<HTMLVideoElement>;
			for (let i = 0; i < videoElementList.length; i++) {
				const videoElement = videoElementList.item(i);
				const sources = videoElement.querySelectorAll('source');
				let hitOne = false;
				for (let j = 0; j < sources.length; j++) {
					const sourceElement = sources.item(j);
					console.log(sourceElement.media, window.matchMedia(sourceElement.media).matches);
					if (!sourceElement.media) {
						if (!hitOne) {
							sourceElement.src = sourceElement.getAttribute("data-src");
						}
					} else if (window.matchMedia(sourceElement.media).matches) {
						sourceElement.src = sourceElement.getAttribute("data-src");
						hitOne = true;
					} else {
						sourceElement.removeAttribute("src");
					}
				}
				videoElement.load();
			}
		};
		mediaQueryBasedSourcesHandler();
		window.addEventListener('resize', mediaQueryBasedSourcesHandler);
	}

	private gfycatInit() {
		const videoElementList = document.querySelectorAll('video[data-gfycatvideoid]') as NodeListOf<HTMLVideoElement>;
		for (let i=0; i < videoElementList.length; i++ ) {
			const videoElement = videoElementList.item(i);
			const videoId = videoElement.getAttribute('data-gfycatvideoid');

			if (videoId) {
				const addSourcesOnVideo = (src: string, type: string) => {
					const sourceEl = document.createElement('source');
					sourceEl.src = src;
					sourceEl.type = type;
					videoElement.appendChild(sourceEl);
				};
				fetch(`https://api.gfycat.com/v1/gfycats/${videoId}`)
					.then((response) => {
						if (response.status >= 200 && response.status < 300) {
							return response;
						} else {
							throw new Error(response.statusText);
						}
					})
					.then(response => response.json())
					.then(json => {
						if (json.gfyItem.webmUrl) {
							addSourcesOnVideo(json.gfyItem.webmUrl, 'video/webm');
						}
						if (json.gfyItem.mp4Url) {
							addSourcesOnVideo(json.gfyItem.mp4Url, 'video/mp4');
						}
						videoElement.play();
					})
					.catch(err => { console.error(err); });
			}
		}
	}
}